module.exports = __webpack_public_path__ + "static/media/music-slash.8f1a9a26.svg";